import { userConstants } from './userConstants';

export function formatBannerTitle(title) {
  if (!title || typeof title !== 'string') return null;
  const trimmed = title.trim();
  if (trimmed === '*') return null;
  return (
    trimmed
      .split(' ')
      .join('-')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^\dA-Za-z-]+/g, '') || null
  );
}

const bannerDimensions = [
  ...userConstants.constans,
  'v_tab',
  'v_banner_title',
];

const rowAdsDimensions = [
  ...userConstants.constans,
  'v_tab',
  'v_button',
  'v_banner_title',
];

export const gtmCommunicationDimensions = {
  row_ads: {
    page_view: {
      hash: 'p-016.207.000.000.000.000',
      eventType: 'pages',
      dimensions: [...rowAdsDimensions],
    },
    banner_click: {
      hash: 'e-016.207.001.000.000.101',
      eventType: 'interactions',
      dimensions: [...rowAdsDimensions],
    },
  },
  home_banner: {
    page_view: {
      hash: 'p-002.205.000.000.000.000',
      eventType: 'pages',
      dimensions: [...bannerDimensions],
    },
    banner_click: {
      hash: 'e-002.205.001.000.000.101',
      eventType: 'interactions',
      dimensions: [...bannerDimensions],
    },
  },
  dialog_banner: {
    page_view: {
      hash: 'p-002.206.000.000.000.000',
      eventType: 'pages',
      dimensions: [...bannerDimensions],
    },
    banner_click: {
      hash: 'e-002.206.001.000.000.101',
      eventType: 'interactions',
      dimensions: [...bannerDimensions],
    },
  },
};
